import { Provider } from "@angular/core";
import { AGGREGATE_ACTION_HANDLERS } from "@tylertech/aggregates-module";
import { PacketActionHandler } from "./aggregateActionHandler/packetActionHandler";
import { PacketService } from "./services/packet.service";
import { ProcessLookupService } from "./services/processLookupService.g";

export function providePackets(): Array<Provider>
{
    return [
        {
            provide: AGGREGATE_ACTION_HANDLERS,
            multi: true,
            useValue: [
                PacketActionHandler
            ],
        },
        PacketActionHandler,
        PacketService,
        ProcessLookupService,
    ];
}
